import { Tag, theme, Typography } from "antd";
import { InputObject } from "./default";
import dayjs, { Dayjs, isDayjs } from "dayjs";
import { ReactNode } from "react";
import { nameOf } from "../utils/typescript";

export interface LabelBoxProps {
  readonly className?: string;
  readonly layout?: "vertical" | "horizontal";
  readonly name?: string;
  readonly value?:
    | InputObject
    | InputObject[]
    | string
    | string[]
    | number
    | number[]
    | boolean
    | boolean[]
    | null;
  readonly format?: (value: any) => any;
  readonly onChange?: (value?: any) => void;
}

function LabelBox(props: LabelBoxProps) {
  const { token } = theme.useToken();

  function readableValue(value?: any): ReactNode {
    if (Array.isArray(value)) {
      return (value as any[]).map((value) => {
        return readableValue(value);
      });
    } else {
      if (value == null) {
        return <></>;
      } else if (
        typeof value === "object" &&
        nameOf<InputObject>("display") in value &&
        nameOf<InputObject>("value") in value
      ) {
        return (
          <Typography.Text className="text-left">
            {value.display?.toString() ?? value.value}
          </Typography.Text>
        );
      } else if (value instanceof Date) {
        return (
          <Typography.Text className="text-left">
            {dayjs(value).format("DD/MM/YYYY")}
          </Typography.Text>
        );
      } else if (isDayjs(value)) {
        return (
          <Typography.Text className="text-left">
            {(value as Dayjs).format("DD/MM/YYYY")}
          </Typography.Text>
        );
      } else if (typeof value === "number") {
        return (
          <Typography.Text className="text-right">{`${value ?? ""}`}</Typography.Text>
        );
      } else if (typeof value === "boolean") {
        return (
          <Tag>
            <Typography.Text
              className="text-right"
              color={value ? "green" : "red"}
            >{`${value ? "Yes" : "No"}`}</Typography.Text>
          </Tag>
        );
      } else {
        return (
          <Typography.Text className="text-left">{`${value ?? ""}`}</Typography.Text>
        );
      }
    }
  }

  const value = props.format
    ? props.format(props.value)
    : readableValue(props.value);

  if (value != null) {
    return (
      <Typography.Text className={`inline-flex flex-col ${props.className}`}>
        {props.name && (
          <Typography.Text
            className="mr-2"
            style={{
              color: token.colorTextDescription,
            }}
          >
            {props.name}
          </Typography.Text>
        )}
        <Typography.Text>{value}</Typography.Text>
      </Typography.Text>
    );
  }

  return <></>;
}

export default LabelBox;
